import { useEffect, useState, useCallback, useMemo } from "react";
import { useChroma } from "../skins/shared/hooks/useChroma";
import { useDebounce } from "./useDebounce";
export const DEFAULT_BREAKPOINTS = {
    mobile: "600px",
    tablet: "1024px",
    desktop: "1920px",
};
export const getBreakpoint = (window, configuredBreakpoints) => {
    if (!window) {
        return "desktop";
    }
    const mobile = configuredBreakpoints.mobile || DEFAULT_BREAKPOINTS.mobile;
    const tablet = configuredBreakpoints.tablet || DEFAULT_BREAKPOINTS.tablet;
    const tabletMin = parseInt(mobile, 10) + 1;
    const desktopMin = parseInt(tablet, 10) + 1;
    if (window.innerWidth < tabletMin) {
        return "mobile";
    }
    else if (tabletMin <= window.innerWidth && window.innerWidth < desktopMin) {
        return "tablet";
    }
    else if (desktopMin <= window.innerWidth) {
        return "desktop";
    }
    else {
        return "desktop";
    }
};
export const useBreakpoint = () => {
    const chroma = useChroma();
    const configuredBreakpoints = useMemo(() => {
        return "breakpoints" in chroma ? chroma.breakpoints : DEFAULT_BREAKPOINTS;
    }, [chroma]);
    const [breakpoint, setBreakpoint] = useState(getBreakpoint(undefined, configuredBreakpoints));
    const handleResize = useCallback(() => {
        setBreakpoint(getBreakpoint(window, configuredBreakpoints));
    }, [configuredBreakpoints]);
    const debouncedHandleResize = useDebounce(handleResize, 1000);
    useEffect(() => {
        handleResize();
        window.addEventListener("resize", debouncedHandleResize, false);
        return () => {
            window.removeEventListener("resize", debouncedHandleResize, false);
        };
    }, [handleResize, debouncedHandleResize]);
    return breakpoint;
};
//# sourceMappingURL=breakpointUtils.js.map